export default __webpack_public_path__ + "static/media/hm-png-img.74df5e9b.webp";